module.exports = __webpack_public_path__ + "img/blacklist.51e2650e.svg";